module.exports = "/fonts/nucleo-icons.svg?e8827b8a8e3df089befd8f417c647515";